import { createApi } from "@reduxjs/toolkit/query/react";
import { BroadcastType } from "./broadcastSlice";
import { baseProxyQueryWithReauth } from "./API";

const el: any = document.querySelector("#app");
export const { contactsClientId, apiBase, csrfToken } = JSON.parse(
  el?.dataset?.page ?? ""
).props;

// Define a service using a base URL and expected endpoints
export const projectsProxyAPI = createApi({
  reducerPath: "projectsProxyAPI",
  baseQuery: baseProxyQueryWithReauth("logic/workflows/api"),
  refetchOnMountOrArgChange: true,
  tagTypes: ["Projects"],
  endpoints: (builder) => ({
    // upsertInboundCampign: builder.mutation<any, Partial<BroadcastType>>({
    //   query: (body) => ({
    //     url: `inbound-rule-handlers`,
    //     method: "POST",
    //     body,
    //   }),
    //   invalidatesTags: ["InboundCampaigns"],
    // }),
    // getProject: builder.query<BroadcastType, string>({
    //   query: (uuid) => `broadcasters/${uuid}`,
    //   providesTags: ["Projects"],
    // }),
    // deleteInboundCampaign: builder.mutation<any, string>({
    //   query: (uuid) => ({
    //     url: `inbound-rule-handlers/${uuid}`,
    //     method: "DELETE",
    //   }),
    //   invalidatesTags: ["Broadcasts"],
    // }),
    getProjects: builder.query<
      { items: BroadcastType[]; total: number },
      {
        limit?: number;
        offset?: number;
        search?: string;
        kind?: string;
        order_by?: "created_at" | "updated_at" | "inbound" | "label" | "hits";
        order?: "asc" | "desc";
        inbound?: string;
        channel?: ("sms" | "email" | "voice")[];
        status?: "active" | "inactive" | "";
        is_wildcard?: boolean;
      }
    >({
      query: (params) => ({
        url: `list-projects`,
        method: "GET",
        params,
      }),
      providesTags: ["Projects"],
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetProjectsQuery, useLazyGetProjectsQuery } =
  projectsProxyAPI;
